import React from 'react';
import styles from './ProgressArc.module.css';

const ProgressArc = ({ questionIndex = 0, totalQuestions = 1 }) => {
  const safeTotal = Math.max(Number(totalQuestions) || 1, 1);
  const current = Math.min(Math.max(Number(questionIndex) || 0, 0), safeTotal);
  const progress = current / safeTotal;
  const radius = 48;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - progress * circumference;

  return (
    <div className={styles.wrap}>
      <svg className={styles.svg} viewBox="0 0 120 120" aria-hidden="true">
        <circle className={styles.track} cx="60" cy="60" r={radius} />
        <circle
          className={styles.fill}
          cx="60"
          cy="60"
          r={radius}
          style={{
            strokeDasharray: circumference,
            strokeDashoffset: offset
          }}
        />
      </svg>
      <div className={styles.meta}>
        <div className={styles.current}>{current}</div>
        <div className={styles.total}>/ {safeTotal}</div>
      </div>
    </div>
  );
};

export default ProgressArc;
